import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/styles/dab.css'

interface IAudioModalProps {
  isShowModal: boolean;
  modalChange: any;
  audioUrl: string;
  title: string;
}

interface IAudioModalState {
  modal: boolean;
  backdrop: string;
}

class AudioModal extends React.Component<IAudioModalProps, IAudioModalState>  {
  state: { modal: boolean; backdrop: string; };
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      backdrop: "static"
    };
    this.toggle = this.toggle.bind(this);
    this.handleOnsubmit = this.handleOnsubmit.bind(this);
  }

  componentDidMount() {
    const { isShowModal } = this.props;
    this.setState({ modal: isShowModal });
  }

  toggle(isDelete) {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
    this.props.modalChange(false, !this.state.modal);
  }

  componentWillReceiveProps(newProps) {
    const oldProps = this.props
    if (oldProps.isShowModal !== newProps.isShowModal) {
      this.setState({ modal: newProps.isShowModal })
    }    
  }

  handleOnsubmit(event) {
    this.toggle(true);
    this.props.modalChange(true, true);
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle} backdrop="static" >
          <ModalHeader className="modal-header" toggle={this.toggle} data-testid="modalTitle">{this.props.title}</ModalHeader>
          <ModalBody className="modal-body">
            {this.props.audioUrl !== null && this.props.audioUrl !== "" &&(
              <audio 
              controls
              src={this.props.audioUrl}>
              <code>audio</code>
              </audio>)}
          </ModalBody>
          <ModalFooter>
				<button type="button" data-testid="modalClose" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.toggle}>Close</button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default AudioModal;